import instanceAxios from "./intanceAxios";

export const typeTaskService = {
    getTypeTasks: async (params) => await instanceAxios.get('/otask/type-tasks/', { params }),
    createTypeTask: async (data) => await instanceAxios.post('/otask/type-tasks/', data),
}